import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "row"]

  connect() {
    this.filter = this.filter.bind(this)
    this.inputTarget.addEventListener("input", this.filter)
  }

  disconnect() {
    this.inputTarget.removeEventListener("input", this.filter)
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    this.rowTargets.forEach((row) => {
      row.classList.toggle("d-none", !row.textContent.toLowerCase().includes(query))
    })
  }
}
